import { FaChevronDown, FaUserCircle, FaSignOutAlt } from "react-icons/fa";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const Topbar = () => {
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const navigate = useNavigate();

	const handleLogout = () => {
		sessionStorage.clear();
		navigate("/login");
	};

	return (
		<header className='bg-white shadow-sm px-6 py-3 flex items-center justify-between'>
			<h1 className='text-lg font-semibold text-gray-800'>SMS Dashboard</h1>

			<div className='relative'>
				<button
					onClick={() => setDropdownOpen(!dropdownOpen)}
					className='flex items-center gap-2 px-4 py-2 bg-gray-100 rounded-full hover:bg-gray-200 transition'
				>
					<FaUserCircle className='text-xl text-blue-600' />
					<span className='text-sm font-medium text-gray-700'>Admin</span>
					<FaChevronDown className='text-sm text-gray-500' />
				</button>

				{dropdownOpen && (
					<div className='absolute right-0 mt-2 w-40 bg-white border rounded-md shadow-lg z-10'>
						<button
							onClick={handleLogout}
							className='w-full flex items-center gap-2 px-4 py-2 text-sm text-red-600 hover:bg-gray-100'
						>
							<FaSignOutAlt /> Logout
						</button>
					</div>
				)}
			</div>
		</header>
	);
};

export default Topbar;
